'use strict'

/* global ga, gtag */

/**
 * @module tips
 */

const CLASS_ACTIV = 'activ'
const CLASS_TRIGGER = 'js-bons-plans'
const CLASS_MODAL = 'js-bons-plans-modal'
const CLASS_MODAL_CONTENT = 'content'
const CLASS_BACKDROP = 'js-backdrop'
const CLASS_LINK = 'js-link'
const CLASS_TIPS_CONTENT = 'content-art'

const DESKTOP_BREAKPOINT = 1024

export default {
  /**
   * @description Initialise tips
   * @returns {undefined}
   */
  init() {
    this.modal = document.getElementById(CLASS_MODAL)
    this.backdrop = document.getElementById(CLASS_BACKDROP)
    this.bind()
  },

  /**
   * @description Bind events on tips elements
   * @returns {undefined}
   */
  bind() {
    document.getElementsByClassName(CLASS_TRIGGER)
            .bindEvent('click', this.dispatchAction.bind(this))
    document.getElementById(CLASS_MODAL).bindEvent('click', '.bons-plans', this.triggerClick)
  },

  triggerClick(e) {
    e.stopPropagation()
    if (e.target.closest('a')) {
      return
    }
    e.customCurrentTarget.querySelector('a').click()
  },

  /**
   * @description test for link and for mobile or desktop
   * @params {event} e MouseEvent
   * @returns {undefined}
   */
  dispatchAction(e) {
    const link = e.target.closest('a')
    if (link && link.classList.contains(CLASS_LINK)) {
      return
    }
    e.preventDefault()
    if (window.innerWidth >= DESKTOP_BREAKPOINT) {
      this.fillModal(e)
    } else {
      this.toggleDesc(e)
    }
  },

  /**
   * @description Ready modal content
   * @params {event} e MouseEvent
   * @returns {undefined}
   */
  fillModal(e) {
    let modalContent = this.modal.getElementsByClassName(CLASS_MODAL_CONTENT).item(0)
    modalContent.innerHTML = e.currentTarget.innerHTML
    this.setModalTracking(modalContent)
    this.openModal(e)
  },

  /**
   * @description add class CLASS_ACTIV on modal & backdrop
   * @params {event} e MouseEvent
   * @returns {undefined}
   */
  openModal(e) {
    e.preventDefault()
    this.backdrop.classList.add(CLASS_ACTIV)
    this.modal.classList.add(CLASS_ACTIV)
  },

  /**
   * @description toggle class CLASS_ACTIV on description
   * @params {event} e MouseEvent
   * @returns {undefined}
   */
  toggleDesc(e) {
    const content = e.currentTarget.getElementsByClassName(CLASS_TIPS_CONTENT).item(0)
    if (content.classList.contains(CLASS_ACTIV)) {
      content.classList.remove(CLASS_ACTIV)
    } else {
      content.classList.add(CLASS_ACTIV)
    }
  },

  /**
   * @description insert ':modal' in the ga function
   * @params {HTMLElement} modalContent modal's content
   * @returns {undefined}
   */
  setModalTracking(modalContent) {
    const link = modalContent.querySelector('a')
    const tagFunction = link.getAttribute('onclick')
    link.setAttribute('onclick', `${tagFunction}`)
    // ga(...this.getParams(tagFunction))
  },
  getParams(func) {
    const params = func.slice(4, -3).split('\', \'')
    params[2] = 'BON PLAN MODAL'
    return params
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/tips.js